import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import colors from '../styles/colors';
import { SU_DashboardFilteresTypes, DashboardFiltersSubTypes } from '../util/CustomerFilterEnum';
import { getFilteredSuperadminContacts } from '../util/customersUtil';
import {
  Card,
  CardHeaderNumber,
  CardContentLine,
} from './MetricsCard';

export default function TotalCouponsRedeemedCard({ metrics, timeRange }) {
  const { setApp } = useContext(AppContext);
  const history = useHistory();
  const isNewClickable = metrics?.totalCouponsRedeemedNew > 0;
  const isReturningClickable = metrics?.totalCouponsRedeemedRepeat > 0;
  const isReferrersClickable = metrics?.totalCouponsRedeemedAffiliate > 0;
  const onClickHandler = (subType) => getFilteredSuperadminContacts(setApp, history, {
    type: SU_DashboardFilteresTypes.DiscountsRedeemed,
    subType,
    ...timeRange,
  });
  return (
    <Card title="Discounts Redeemed">
      <CardHeaderNumber>{metrics.totalCouponsRedeemed.toLocaleString()}</CardHeaderNumber>
      <CardContentLine
        left="New Customers"
        right={metrics.totalCouponsRedeemedNew.toLocaleString()}
        color={isNewClickable ? colors.seaGreen : colors.grey2}
        onClick={isNewClickable ? () => onClickHandler(DashboardFiltersSubTypes.New) : null}
      />
      <CardContentLine
        left="Returning Customers"
        right={metrics.totalCouponsRedeemedRepeat.toLocaleString()}
        color={isReturningClickable ? colors.seaGreen : colors.grey2}
        onClick={isReturningClickable ? () => onClickHandler(DashboardFiltersSubTypes.Returning) : null}
      />
      <CardContentLine
        left="Referrers"
        right={metrics.totalCouponsRedeemedAffiliate.toLocaleString()}
        color={isReferrersClickable ? colors.seaGreen : colors.grey2}
        onClick={isReferrersClickable ? () => onClickHandler(DashboardFiltersSubTypes.Referrers) : null}
      />
    </Card>
  );
}
